import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { EditButton, List, useDataGrid } from "@refinedev/mui";
import React from "react";
import { FormControlLabel } from "@mui/material";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { DeleteButton } from "components/buttons/delete";
import { useNavigate } from "react-router-dom";

const App = () => {
  const navigate = useNavigate();

  const [userId, setUserId] = useState<string>("");
  const [email, setEmail] = useState<string>("");

  const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
    sorters: {
      initial: [
        {
          field: "updatedAt",
          order: "desc",
        },
      ],
    },
    pagination: {
      pageSize: 10,
    },
  });

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "userId",
        headerName: "UserId",
        minWidth: 100,
        hideable: false,
      },
      {
        field: "email",
        headerName: "Email",
        minWidth: 300,
        hideable: false,
      },
      {
        field: "modules",
        headerName: "Modules",
        minWidth: 200,
        flex: 1,
        hideable: false,
        sortable: false,
      },
      {
        field: "createdAt",
        headerName: "createdAt",
        minWidth: 160,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.createdAt) {
            return new Date(row.createdAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "updatedAt",
        headerName: "UpdatedAt",
        minWidth: 160,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.updatedAt) {
            return new Date(row.updatedAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "action",
        headerName: "Actions",
        hideable: false,
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton
                hideText
                recordItemId={row.userId}
                onClick={() => {
                  navigate("/analyticsWatchLists/edit", { state: row });
                }}
              />
              <DeleteButton hideText recordItemId={row.userId} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 100,
      },
    ],
    []
  );

  const handleFilter = () => {
    setCurrent(1);
    setPageSize(10);
    let searchArr: { field: string; value: string; operator: string }[] = [];
    if (userId) {
      searchArr.push({
        field: "userId[$ilike]",
        value: `${userId}`,
        operator: "eq",
      });
    }
    if (email) {
      searchArr.push({
        field: "email[$ilike]",
        value: `${email}`,
        operator: "eq",
      });
    }
    setFilters(searchArr as any);
  };

  const clearFun = () => {
    setUserId("");
    setEmail("");
    setFilters([]);
  };

  return (
    <List>
      <div>
        The list used to activate uploading client logs to analytics db.
      </div>
      <FormControlLabel
        label=""
        style={{ width: "100%" }}
        control={
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <TextField
                id="standard-basic"
                label="userId"
                variant="standard"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                style={{ width: "30%" }}
              />
              <TextField
                id="standard-basic"
                label="Email"
                variant="standard"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: "30%" }}
              />
              <div style={{ width: "30%" }}>
                <ClearOutlinedIcon onClick={clearFun} />
                <SearchIcon onClick={handleFilter} />
              </div>
            </div>
          </div>
        }
      />
      <DataGrid
        getRowId={(e) => e.userId}
        {...dataGridProps}
        columns={columns}
        autoHeight
        paginationMode="server"
        rowsPerPageOptions={[10, 20, 50]}
        disableColumnFilter
      />
    </List>
  );
};

export default App;
